import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Signout } from "../../../api/User/Auth/registerApi";
import { clearClientData } from "../../../Redux/Reducer/ClientDataReducer";
import { clearUserDetails } from "../../../Redux/Reducer/UserDetailsReducer";
import Fontstyling from "../comman";

export default function LogoutModal({ show, setModal, navigate }) {
  const dispatch = useDispatch();
  const handelLogout = () => {
    let provider = localStorage.getItem('provider')
    Signout(provider)
      .then((res) => {
        if (res.status) {
          localStorage.removeItem("token");
          dispatch(clearClientData(null));
          dispatch(clearUserDetails(null));
          navigate("/");
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          navigate("/");
        }
      });
  };
  return (
    <>
      <Modal show={show} onHide={() => setModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={Fontstyling.modalHeading}>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-nowrap">
          Are you sure you want to logout ?
        </Modal.Body>
        <Modal.Footer>
          <button style={Fontstyling.savebutton} onClick={() => handelLogout()}>
            Yes
          </button>
          <button
            style={Fontstyling.cancelbutton}
            onClick={() => setModal(false)}
          >
            No
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
